const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1199,
    lg: 1920,
    xl: 2100
  }
};

export default breakpoints;
